import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";

import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import SleevesContainer from "~/Components/Containers/SleevesContainer";
import SleeveMini from "~/Components/SleeveMini";
import Pager from "../../Components/Global/Pager";

const BrowseAllPage = ({ location }) => {
  let history = useHistory();
  const queryStringParams = queryString.parse(location.search);
  const { page: startPage = 1 } = queryStringParams;
  const [page, setPage] = useState(parseInt(startPage, 10));

  const updatePageCallBack = (toPage) => {
    history.push("?page=" + toPage);
    setPage(toPage);
  };

  return (
    <div className="page-home">
      <Helmet>
        <title>Sleevery | Browse All Sleeves | Dream Chimney</title>
      </Helmet>
      <Row>
        <Col xs={12}>
          <h1 className="page-header">Browse All Sleeves</h1>
        </Col>
      </Row>

      <SleevesContainer
        page={page}
        render={({ result }) => {
          const { sleeves, perPage, total } = result;
          const pages = Math.ceil(total / perPage);

          if (sleeves.length === 0) return null;
          return (
            <Row>
              <Col xs={12}>
                <ul className="results cover-wall">
                  {sleeves.map((sleeve) => (
                    <li key={sleeve.id}>
                      <SleeveMini sleeve={sleeve} />
                    </li>
                  ))}
                </ul>
              </Col>

              <Col xs={12}>
                <div className="pagination-footer" style={{ padding: "20px 0" }}>
                  <Pager className="pagination-footer" page={page} pages={pages} updatePage={updatePageCallBack} />
                </div>
              </Col>
            </Row>
          );
        }}
      />
    </div>
  );
};

export default BrowseAllPage;
